// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    manufacturerGetDataResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getManufacturer({ payload }) {
    try {
        let QUERY = `
            query getManufacturer ($id: Int!) {
                result: getManufacturer (id: $id) {
                    id
                    name
                    active
                    createdOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(manufacturerGetDataResult(data?.result))

    } catch (exc) {
        yield put(manufacturerGetDataResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/views/overview/redux/saga",
            "getManufacturer"
        )
    }
}

function* watchMethods() {
    yield takeEvery(MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST, getManufacturer);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}